<template>
   <b-form-group :class="wrapperClass">
    <b-input-group>
      <b-form-input :placeholder="placeholder || this.$t('global.search')"
        :autocomplete="autocomplete"
        :readonly="readonly"
        :disabled="disabled"
        :size="size"
        v-model="value" />
        <b-input-group-append>
          <b-button variant="primary" @click="$emit('click')" :size="size"><i :class="icon" /></b-button>
        </b-input-group-append>
      </b-input-group>
  </b-form-group>
</template>
<script>
import debounce from 'lodash.debounce';

export default {
  name: 'DebouncedSearch',
  props: {
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    modelValue: {
      type: String,
      required: false
    },
    wrapperClass: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'fa fa-search'
    },
    autocomplete: {
      type: String,
      default: undefined
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputId: {
      type: String,
      default: undefined
    },
    size: {
      type: String,
      default: undefined
    }
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      // eslint-disable-next-line func-names
      set: debounce(function (val) {
        // with vue 3 this will need to be update:modelValue instead of input
        this.$emit('input', val);
      }, 300)
    },
  }
};
</script>
